import Voucher from './routes/voucher/Voucher.vue';
import ReservationLog from './routes/reservation_log/ReservationLog.vue';
import MyVoucherTab from './routes/my_voucher_tab/MyVoucherTab.vue';
import ImageURLGenerator from './routes/image_url_generator/ImageURLGenerator.vue';
import CreateImageURLGenerator from './routes/image_url_generator/components/CreateImageURLGenerator.vue';
import EditImageURLGenerator from './routes/image_url_generator/components/EditImageURLGenerator.vue';
import SpecialVoucher from './routes/special_voucher/SpecialVoucher.vue';

const PromoRoutes = [
  {
    path: 'reservation-log',
    name: 'ReservationLog',
    component: ReservationLog,
  },
  {
    path: 'voucher',
    name: 'Voucher',
    component: Voucher,
  },
  {
    path: 'my-voucher-tab',
    name: 'MyVoucherTab',
    component: MyVoucherTab,
  },
  {
    path: 'image-url-generator',
    name: 'ImageURLGenerator',
    component: ImageURLGenerator,
  },
  {
    path: 'create-image-url-generator',
    name: 'CreateImageURLGenerator',
    component: CreateImageURLGenerator,
  },
  {
    path: 'edit-image-url-generator/:id',
    name: 'EditImageURLGenerator',
    component: EditImageURLGenerator,
  },
  {
    path: 'special-voucher',
    name: 'SpecialVoucher',
    component: SpecialVoucher,
  },
];

export default PromoRoutes;